var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("div", { staticClass: "blocks" }, [
        _c(
          "div",
          {
            staticClass:
              "pt-3 l-m-b-20 align-items-center d-flex justify-content-between"
          },
          [
            _c("div", { staticClass: "d-flex align-items-center" }, [
              _c("h1", { staticClass: "pr-3 w-full" }, [
                _vm._v("Ratings & Reviews")
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "input-group search" }, [
                _c(
                  "button",
                  {
                    staticClass: "btn input-group-btn",
                    attrs: { type: "button" },
                    on: { click: _vm.clearSearch }
                  },
                  [
                    _c("i", {
                      class: [_vm.q ? "fa fa-remove" : "fa fa-search"]
                    })
                  ]
                ),
                _vm._v(" "),
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.q,
                      expression: "q"
                    }
                  ],
                  staticClass: "form-control",
                  attrs: { type: "text", placeholder: "Search" },
                  domProps: { value: _vm.q },
                  on: {
                    keyup: function($event) {
                      _vm.searchText($event)
                    },
                    input: function($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.q = $event.target.value
                    }
                  }
                })
              ])
            ])
          ]
        ),
        _vm._v(" "),
        _c("div", { staticClass: "row" }, [
          _c("div", { staticClass: "col-11 filters-field" }, [
            _c("span", [_vm._v("Filters:")]),
            _vm._v(" "),
            _vm.filtersLoaded
              ? _c("span", [
                  _vm.filters.companyStatus &&
                  _vm.companyStatuses &&
                  _vm.companyStatuses.length > 0
                    ? _c(
                        "span",
                        { staticClass: "filter-item btn btn-filter" },
                        [
                          _c("span", {
                            staticClass: "mod-icon-filter",
                            on: {
                              click: function($event) {
                                _vm.removeFilter("companyStatus")
                              }
                            }
                          }),
                          _vm._v(
                            "\n            Status: " +
                              _vm._s(
                                _vm.companyStatuses.find(function(el) {
                                  return el.id === _vm.filters.companyStatus
                                }).name
                              )
                          )
                        ]
                      )
                    : _vm._e()
                ])
              : _vm._e(),
            _vm._v(" "),
            _c(
              "button",
              {
                staticClass: "btn btn-secondary add-filters",
                on: {
                  click: function($event) {
                    _vm.showFilters = true
                  }
                }
              },
              [_c("i", { staticClass: "fa fa-plus filter-icon" })]
            )
          ])
        ])
      ]),
      _vm._v(" "),
      !_vm.companies
        ? [
            _c(
              "vue-content-loading",
              { attrs: { width: 800, height: 450 } },
              _vm._l(15, function(x) {
                return _c("rect", {
                  key: x,
                  attrs: {
                    x: "10",
                    y: 15 * x * 1.4,
                    rx: "5",
                    ry: "5",
                    width: "720",
                    height: "6"
                  }
                })
              })
            )
          ]
        : [
            _c(
              "div",
              { staticClass: "blocks" },
              _vm._l(_vm.companies, function(company, index) {
                return _c("RatingsBlock", {
                  key: index,
                  attrs: { company: company },
                  on: {
                    "update:company": function($event) {
                      company = $event
                    }
                  }
                })
              })
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "row blocks" },
              [
                _vm.meta.total
                  ? _c(
                      "div",
                      { staticClass: "col-sm-6 mb-1 text-black-50 pl-0" },
                      [
                        _vm._v(
                          "\n        Showing " +
                            _vm._s(_vm.meta.from) +
                            " - " +
                            _vm._s(_vm.meta.to) +
                            " of " +
                            _vm._s(_vm.meta.total) +
                            "\n      "
                        )
                      ]
                    )
                  : _vm._e(),
                _vm._v(" "),
                _c("pagination", {
                  staticClass: "col-sm-6 mb-1 pr-0",
                  attrs: { "change-page": _vm.changePage, meta: _vm.meta }
                })
              ],
              1
            )
          ],
      _vm._v(" "),
      _c("transition", { attrs: { name: "slide-fade" } }, [
        _vm.showFilters
          ? _c(
              "div",
              {
                staticClass: "l-modal-mask",
                on: {
                  click: function($event) {
                    if ($event.target !== $event.currentTarget) {
                      return null
                    }
                    _vm.showFilters = false
                  }
                }
              },
              [
                _vm.showFilters
                  ? _c(
                      "div",
                      { staticClass: "filters-side-modal flex flex-column" },
                      [
                        _c(
                          "div",
                          {
                            staticClass: "pointer",
                            on: {
                              click: function($event) {
                                _vm.showFilters = !_vm.showFilters
                              }
                            }
                          },
                          [
                            _c("h1", { staticClass: "modal-h1 l-m-b-20" }, [
                              _c("span", { staticClass: "btn btn-back" }),
                              _vm._v("Add Filter")
                            ])
                          ]
                        ),
                        _vm._v(" "),
                        _c("div", [
                          _c("p", [
                            _vm._v(
                              "\n            Filters are applied automatically. You can remove them one by one with minus button or with clear filters button.\n          "
                            )
                          ])
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "l-bg-white" }, [
                          _c("div", { staticClass: "row" }, [
                            _c("div", { staticClass: "col" }, [
                              _c("div", { staticClass: "row filters" }, [
                                _c("div", { staticClass: "col-12" }, [
                                  _c(
                                    "div",
                                    { staticClass: "select-wrap" },
                                    [
                                      _c("label", [_vm._v("Company Status")]),
                                      _vm._v(" "),
                                      _c("simple-select", {
                                        attrs: {
                                          options: _vm.companyStatuses,
                                          placeholder: "Select Status"
                                        },
                                        on: { input: _vm.search },
                                        model: {
                                          value: _vm.filters.companyStatus,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.filters,
                                              "companyStatus",
                                              $$v
                                            )
                                          },
                                          expression: "filters.companyStatus"
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ])
                              ])
                            ])
                          ])
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "row mt-auto" }, [
                          _c("div", { staticClass: "col" }, [
                            _vm.filters.companyStatus
                              ? _c(
                                  "button",
                                  {
                                    staticClass:
                                      "btn btn-not-active text-dark w-100",
                                    attrs: { type: "button" },
                                    on: { click: _vm.clearFilters }
                                  },
                                  [
                                    _vm._v(
                                      "\n              Clear filters\n            "
                                    )
                                  ]
                                )
                              : _vm._e()
                          ])
                        ])
                      ]
                    )
                  : _vm._e()
              ]
            )
          : _vm._e()
      ])
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-6174af0d", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6174af0d","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/reports/ratings/Ratings.vue
// module id = null
// module chunks = 